// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kxhKN","content":"styles_content__-3W-b","row":"styles_row__1bXjd","footer":"styles_footer__3LLaS","phraseLength":"styles_phraseLength__1B2OM"};